import $ from "jquery";

export default class PopoverForm {
  constructor(element) {
    this.element = $(element);
    this.element.on("inserted.bs.popover", this.popoverOpened.bind(this));
    // (BS5): seed a non-empty placeholder content. BS5 refuses to show a popover whose
    // title+content are both empty (the _isWithContent gate), and our real body is AJAX-loaded
    // only AFTER the popover is inserted — without a seed the popover never opens. The seed is
    // replaced by popoverOpened()'s .load(). (The BS3 issue-16732 `hidden.bs.popover` reopen
    // workaround was removed: BS5 fixed that bug, and `$(el).data("bs.popover")` is undefined
    // under BS5 — instances live in Bootstrap's own registry, not jQuery .data — so it threw.)
    this.element.popover({ content: " " });
  }

  popoverOpened() {
    this.popover = this.getPopoverElement();
    // (BS5): the popover content container was renamed `.popover-content` → `.popover-body`.
    this.popoverContent = this.popover.find(".popover-body");
    const url = $(this.element).data("content-url");
    this.popoverContent.load(url, (response, status, xhr) => this.popoverLoaded(response, status, xhr));
  }

  closePopover() {
    this.element.popover("hide");
  }

  popoverLoaded(response, status /*, xhr*/) {
    if (status == "error") {
      return this.showError(response);
    }
    this.popoverContent.find(".cancel").on("click", this.closePopover.bind(this));
    this.popoverContent.find("form").on("ajax:success", this.closePopover.bind(this));
    $(this.element).trigger("loaded.bs.popover");
  }

  getPopoverElement() {
    return $(this.element).parent().find(".popover");
  }

  showError(error) {
    window.alert("Error: " + error);
  }
}
